import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc.js'
import timezone from 'dayjs/plugin/timezone.js'
dayjs.extend(utc);
dayjs.extend(timezone);
import getItemStyles from '../../../utils/item-styles.js';
import fixAmAndPm from '../../../../../utils/fixAmAndPm.js';
import ignoreDummyComments from '../../../../../utils/ignoreDummyComments.js';
import daylightSavingsCheck from '../../../../../utils/daylightSavingsCheck.js';

/**
 *
 * @param {String} startTime
 * @param {*} dayType
 * @param {*} resource
 */
const generateTour = (tourStartTime, dayType, resource, startDate, scheduleType, scheduleFormat, timeZoneOffset,securityLevels) => {
    let startTime = dayjs(dayjs.unix(tourStartTime).utc().format("YYYY-MM-DD HH:mm:ss"));
    const validateStatus = (status) => {
        return status != 1;/*None*/  
      }
    const { rId  } = resource;
    const { rdtId } = dayType;

    const { tourId, duration, notificationComment, tourComment, abbreviation, isApproved,tourContract } = dayType.tour;
    let hasComment = false;
    if ( ignoreDummyComments(notificationComment || tourComment ) ) {
        hasComment = true;
    }
    const isOvertime = tourHasOvertime(dayType);
    let tourStyle;
    if (isOvertime) {
        tourStyle = getItemStyles('overtime');
    } else tourStyle = getItemStyles('tour');
    const adjustedTitle = createTitle(abbreviation, startTime, duration, startDate, scheduleType, scheduleFormat, timeZoneOffset);

    if (daylightSavingsCheck(startDate) === 'springForwardDay'
        || (daylightSavingsCheck(dayjs(startDate)) === false
        && daylightSavingsCheck(dayjs(startDate).add(scheduleFormat - 1, 'day')) === true)
    ) {
        startTime = startTime.add(timeZoneOffset + 60, 'minute');  // DST fix: only temporary, won't work in all timezones
    } else {
        startTime = startTime.add(timeZoneOffset, 'minute'); // necessary for each day the rest of the year
    }
    let strTooltip = adjustedTitle;
    if (securityLevels) {
        strTooltip+="\n";
        strTooltip += validateStatus(securityLevels.scheduleTourContract) ? 'Tour Contract: '+ tourContract : ''
    }
    
      let tour = {
        id: tourId,
        rdtId,
        itemType: 'tour',
        group: rId,
        title:  strTooltip,
        tooltipText: adjustedTitle,
        start_time: startTime.startOf('day'),
        end_time: startTime.endOf('day'),
        date: dayjs(startTime).format('MM-DD-YYYY'),
        backgroundColor: dayType.tour.isApproved ? "gray" : tourStyle.backgroundColor,
        borderStyle: tourStyle.borderStyle,
        borderColor: hasComment ? 'red' : tourStyle.borderColor,
        isApproved
    };

    return tour;
}

const createTitle = (abbreviation, startTime, duration, startDate, scheduleType, scheduleFormat, timeZoneOffset) => {
    let DSTNeutralStartTime = startTime;

    let adjustedTime = fixAmAndPm(dayjs(DSTNeutralStartTime).format('h:mma')) + '-'
    + fixAmAndPm(dayjs(DSTNeutralStartTime).add(duration, 'hour').format('h:mma'));
    
    if(process.env.NODE_ENV === 'test'){
        let testingTour = fixAmAndPm(dayjs(startTime).format('h:mma')) + 
        '-' + fixAmAndPm(dayjs(startTime).add(duration, 'hour').format('h:mma'));
        return testingTour + ' ' + abbreviation;
    }

    return adjustedTime + ' ' + abbreviation;
}

const tourHasOvertime = (dayType) => {

    // If the title has overtime it must have overtime
    if ( dayType.title && (dayType.title.includes('Overtime') || dayType.title.includes('OT')) ) {
        return true;
    }

    // Reading whether tourPayTransactions have a value of OT and thus an OT tour
    if (dayType.tour.tourPayTransactions) {
        if (typeof(dayType.tour.tourPayTransactions[0]) === 'object') {
            for (let tourPayTransactions of dayType.tour.tourPayTransactions) {
                if (tourPayTransactions.code === 'OT') {
                    return true;
                }
            }
        } else {
            for (let code of dayType.tour.tourPayTransactions) {
                if (code === 'OT') {
                    return true;
                }
            }
        }
    }
    return false;
}

export default generateTour;
